import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { AddressEntity } from '@printdeal/address-frontend/types';
import { ServiceFactory } from '../../../../../../services/ServiceFactory';

type SetBillingAddressRequest = {
  address: AddressEntity,
};

type SetBillingAddressResponse = void;

interface Props {
  orderId: string;
}

export default function useSetBillingAddressMutation({ orderId }: Props): UseMutationResult<
SetBillingAddressResponse,
unknown,
SetBillingAddressRequest
> {
  const orderService = ServiceFactory.createOrderService();

  return useMutation({
    mutationKey: ['setBillingAddressOnOrder', orderId],
    mutationFn: async ({ address }: SetBillingAddressRequest): Promise<SetBillingAddressResponse> => {
      const data = await orderService.setBillingAddress(orderId, address);

      return data;
    },
  });
}
